<template>
  <v-app class="white">
    <div class="products-page pt-4 px-2 py-2">
      <div class="white my-rounded p-3">
        <div class="my-container">
        <!-- <h5 class="text-color px-3 mb-12">محصولات</h5> -->
        <div class="d-flex justify-content-between"></div>
        <div class="add-product">
          <router-link :to="{ name: 'Golpino Seller Product Form' }">
            <custom-button
              classes="add-button"
              label="+ افزودن محصول "
            ></custom-button>
          </router-link>
        </div>
        <div class="text-center">
          <div class="d-inline-block mx-1 available mb-1" v-if="products">
            تعداد محصولات موجود:
            {{ products.filter((item) => item.status === 1).length }}
          </div>
          <div class="d-inline-block mx-1 not available" v-if="products">
            تعداد محصولات ناموجود:
            {{ products.filter((item) => item.status === 0).length }}
          </div>
        </div>
        <v-row>
          <v-col :cols="12">
            <v-text-field
              v-model="searchTerm"
              placeholder="جستجوی محصولات"
              color="#eb307b"
              :loading="loading"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      </div>
      <div class="mt-2">
        <div class="product-tools d-flex justify-content-between">
          <div class="mini-title"></div>
        </div>
        <div class="products-table mt-2 desktopPro">
          <v-simple-table v-if="products">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>تصویر</th>
                  <th>نام محصول</th>
                  <th>دسته بندی</th>
                  <th>قیمت</th>
                  <th>قیمت با تخفیف</th>
                  <th>تعداد</th>
                  <th>تاریخ</th>
                  <th>اقدامات</th>
                  <th>موجود</th>
                </tr>
              </thead>
              <tbody>
                <product-item
                  @deleteMe="deleteProduct"
                  browser-size="desktop"
                  v-for="(p, i) in products.filter((product) => {
                    return product.name.toLowerCase().includes(searchTerm);
                  })"
                  :key="i"
                  :theProduct="p"
                ></product-item>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="mobilePro" v-if="products">
          <product-item-mobile-view
            @deleteMe="deleteProduct"
            browser-size="mobile"
            v-for="(p, i) in products.filter((product) => {
              return product.name.toLowerCase().includes(this.searchTerm);
            })"
            :key="i"
            :theProduct="p"
          />
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import { ref, onMounted, computed } from "@vue/composition-api";
import CustomButton from "../Common/customButton";
import IconImage from "../Common/icon";
import CustomInput from "../Common/CustomInput";
import ProductItem from "./partials/productItem";
import Service from "../../../utils/seller-service";
import ProductItemMobileView from "./partials/productItemMobileView";

export default {
  data: () => ({
    searchTerm: "",
    loading: false,
  }),
  components: {
    ProductItemMobileView,
    CustomButton,
    CustomInput,
    IconImage,
    ProductItem,
  },
  setup() {
    onMounted(() => {
      getProducts();
    });

    const authService = computed(() => {
      return Service(true);
    });
    const products = ref(null);

    const getProducts = () => {
      authService.value.receive(
        "seller/product",
        {},
        (s, d) => {
          if (s == 200) products.value = d.data;
          var moment = require("jalali-moment");
          products.value.map((p) => {
            p.created_at = moment(
              p.created_at.toString().substr(0, 10),
              "YYYY-MM-DD"
            )
              .locale("fa")
              .format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    const model = ref(null);

    const deleteProduct = (id) => {
      authService.value.remove(
        "seller/product/" + id,
        {},
        (s, d) => {
          if (s == 200) alert("محصول پاک شد");
          getProducts();
        },
        (s, e) => {}
      );
    };

    return { products, model, deleteProduct };
  },
};
</script>
<style lang="scss" scoped>
.back {
  // background: #e4e3e3;
  background: #f8f8f8;
}
@media only screen and (max-width: 800px) {
  .desktopPro {
    display: none;
  }

}

@media only screen and (min-width: 800px) {
  .mobilePro {
    display: none;
  }

  .desktopPro {
    /*display: none;*/
    width: 100%;
  }

  .products {
    background-color: white;
  }
}
.products-table{
  border-radius: 15px;
}
.products-page {
  font-weight: lighter;
  font-size: 0.8rem;
  border-radius: 15px;
  background: rgb(243, 243, 243);

}

h2 {
  font-weight: lighter;
  font-size: 1.2rem;
}

.list-nav-button {
  border: none;
}

.products {
  // padding: 12px 18px 0px 18px;
}

.product-table {
  width: 100%;
}

table {
  border-collapse: collapse;
  border-spacing: 20px 10px;
  width: 100%;
  font-size: 0.75rem;
}

th {
  /* background-color: #c8c8c8; */
  cursor: pointer;
}

td {
  /*border: none!important;*/
  font-family: inherit !important;
  font-size: 12px !important;
  text-align: center !important;
  background-color: white !important;
}

th {
  border: none !important;
  font-family: inherit !important;
  font-size: 12px !important;
  text-align: right !important;
  background-color: white !important;
}
.my-container {
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  padding: 0 5px;
}
.available {
  width: 170px;
  padding: 10px 0;
  border-radius: 25px;
  background: #93ecf2;
  text-align: center;
  color: #607d8b;
  font-weight: 400;
  &.not {
    background: #ffdef3;
  }
}
.v-data-table.theme--light{
  border-radius: 15px;
  overflow: auto;
}
.add-product {
  overflow: hidden !important;
  position: fixed !important;
  bottom: 80px !important;
  width: fit-content !important;
  z-index: 200 !important;
  left: 20px !important;
  border-radius: 30px !important;
}
.my-rounded{
  border-radius: 15px;
}
#app{
  .theme--light.v-application{
    background: #f3f3f3;
  }
}
</style>